/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListResponseArgsOfVorschlagArtikelDto } from '../models/list-response-args-of-vorschlag-artikel-dto';
import { ExtendedQueryTokenDTO } from '../models/extended-query-token-dto';
import { ResponseArgsOfVorschlagArtikelDto } from '../models/response-args-of-vorschlag-artikel-dto';
import { VorschlagArtikelDto } from '../models/vorschlag-artikel-dto';
import { ResponseArgsOfBoolean } from '../models/response-args-of-boolean';
@Injectable({
  providedIn: 'root',
})
class MandantService extends __BaseService {
  static readonly MandantQueryPath = '/vorschlag/s';
  static readonly MandantCreatePath = '/vorschlag';
  static readonly MandantUpdatePath = '/vorschlag/{catalogProductNumber}/{datum}';
  static readonly MandantDeletePath = '/vorschlag/{catalogProductNumber}/{datum}';
  static readonly MandantDeferPath = '/vorschlag/defer/{catalogProductNumber}/{sortimentId}/{days}';
  static readonly MandantRemovePath = '/vorschlag/remove/{catalogProductNumber}/{sortimentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Query
   * @param params The `MandantService.MandantQueryParams` containing the following parameters:
   *
   * - `queryToken`:
   *
   * - `eagerLoading`:
   */
  MandantQueryResponse(params: MandantService.MandantQueryParams): __Observable<__StrictHttpResponse<ListResponseArgsOfVorschlagArtikelDto>> {
    let __params = this.newParams();
    const __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.queryToken;
    if (params.eagerLoading != null) __params = __params.set('eagerLoading', params.eagerLoading.toString());
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/vorschlag/s`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListResponseArgsOfVorschlagArtikelDto>;
      })
    );
  }
  /**
   * Query
   * @param params The `MandantService.MandantQueryParams` containing the following parameters:
   *
   * - `queryToken`:
   *
   * - `eagerLoading`:
   */
  MandantQuery(params: MandantService.MandantQueryParams): __Observable<ListResponseArgsOfVorschlagArtikelDto> {
    return this.MandantQueryResponse(params).pipe(
      __map(_r => _r.body as ListResponseArgsOfVorschlagArtikelDto)
    );
  }

  /**
   * Create
   * @param payload VorschlagArtikelDto
   */
  MandantCreateResponse(payload: VorschlagArtikelDto): __Observable<__StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/vorschlag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>;
      })
    );
  }
  /**
   * Create
   * @param payload VorschlagArtikelDto
   */
  MandantCreate(payload: VorschlagArtikelDto): __Observable<ResponseArgsOfVorschlagArtikelDto> {
    return this.MandantCreateResponse(payload).pipe(
      __map(_r => _r.body as ResponseArgsOfVorschlagArtikelDto)
    );
  }

  /**
   * Update
   * @param params The `MandantService.MandantUpdateParams` containing the following parameters:
   *
   * - `payload`:
   *
   * - `datum`:
   *
   * - `catalogProductNumber`:
   */
  MandantUpdateResponse(params: MandantService.MandantUpdateParams): __Observable<__StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.payload;


    const req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/vorschlag/${encodeURIComponent(String(params.catalogProductNumber))}/${encodeURIComponent(String(params.datum))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>;
      })
    );
  }
  /**
   * Update
   * @param params The `MandantService.MandantUpdateParams` containing the following parameters:
   *
   * - `payload`:
   *
   * - `datum`:
   *
   * - `catalogProductNumber`:
   */
  MandantUpdate(params: MandantService.MandantUpdateParams): __Observable<ResponseArgsOfVorschlagArtikelDto> {
    return this.MandantUpdateResponse(params).pipe(
      __map(_r => _r.body as ResponseArgsOfVorschlagArtikelDto)
    );
  }

  /**
   * Delete
   * @param params The `MandantService.MandantDeleteParams` containing the following parameters:
   *
   * - `datum`:
   *
   * - `catalogProductNumber`:
   */
  MandantDeleteResponse(params: MandantService.MandantDeleteParams): __Observable<__StrictHttpResponse<ResponseArgsOfBoolean>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;


    const req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/vorschlag/${encodeURIComponent(String(params.catalogProductNumber))}/${encodeURIComponent(String(params.datum))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponseArgsOfBoolean>;
      })
    );
  }
  /**
   * Delete
   * @param params The `MandantService.MandantDeleteParams` containing the following parameters:
   *
   * - `datum`:
   *
   * - `catalogProductNumber`:
   */
  MandantDelete(params: MandantService.MandantDeleteParams): __Observable<ResponseArgsOfBoolean> {
    return this.MandantDeleteResponse(params).pipe(
      __map(_r => _r.body as ResponseArgsOfBoolean)
    );
  }

  /**
   * Vorschlag zurückstellen (Für eine definierte Zeit nicht mehr berücksichtigen)
   * @param params The `MandantService.MandantDeferParams` containing the following parameters:
   *
   * - `sortimentId`:
   *
   * - `days`: Vorschlag für diese Anzahl von Tagen nicht mehr berücksichtigen
   *
   * - `catalogProductNumber`:
   */
  MandantDeferResponse(params: MandantService.MandantDeferParams): __Observable<__StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;



    const req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/vorschlag/defer/${encodeURIComponent(String(params.catalogProductNumber))}/${encodeURIComponent(String(params.sortimentId))}/${encodeURIComponent(String(params.days))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>;
      })
    );
  }
  /**
   * Vorschlag zurückstellen (Für eine definierte Zeit nicht mehr berücksichtigen)
   * @param params The `MandantService.MandantDeferParams` containing the following parameters:
   *
   * - `sortimentId`:
   *
   * - `days`: Vorschlag für diese Anzahl von Tagen nicht mehr berücksichtigen
   *
   * - `catalogProductNumber`:
   */
  MandantDefer(params: MandantService.MandantDeferParams): __Observable<ResponseArgsOfVorschlagArtikelDto> {
    return this.MandantDeferResponse(params).pipe(
      __map(_r => _r.body as ResponseArgsOfVorschlagArtikelDto)
    );
  }

  /**
   * Vorschlag löschen (Bis zum nächsten Import)
   * @param params The `MandantService.MandantRemoveParams` containing the following parameters:
   *
   * - `sortimentId`:
   *
   * - `catalogProductNumber`:
   */
  MandantRemoveResponse(params: MandantService.MandantRemoveParams): __Observable<__StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>> {
    const __params = this.newParams();
    const __headers = new HttpHeaders();
    const __body: any = null;


    const req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/vorschlag/remove/${encodeURIComponent(String(params.catalogProductNumber))}/${encodeURIComponent(String(params.sortimentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResponseArgsOfVorschlagArtikelDto>;
      })
    );
  }
  /**
   * Vorschlag löschen (Bis zum nächsten Import)
   * @param params The `MandantService.MandantRemoveParams` containing the following parameters:
   *
   * - `sortimentId`:
   *
   * - `catalogProductNumber`:
   */
  MandantRemove(params: MandantService.MandantRemoveParams): __Observable<ResponseArgsOfVorschlagArtikelDto> {
    return this.MandantRemoveResponse(params).pipe(
      __map(_r => _r.body as ResponseArgsOfVorschlagArtikelDto)
    );
  }
}

module MandantService {

  /**
   * Parameters for MandantQuery
   */
  export interface MandantQueryParams {
    queryToken: ExtendedQueryTokenDTO;
    eagerLoading?: number;
  }

  /**
   * Parameters for MandantUpdate
   */
  export interface MandantUpdateParams {
    payload: VorschlagArtikelDto;
    datum: string;
    catalogProductNumber: string;
  }

  /**
   * Parameters for MandantDelete
   */
  export interface MandantDeleteParams {
    datum: string;
    catalogProductNumber: string;
  }

  /**
   * Parameters for MandantDefer
   */
  export interface MandantDeferParams {
    sortimentId: number;

    /**
     * Vorschlag für diese Anzahl von Tagen nicht mehr berücksichtigen
     */
    days: number;
    catalogProductNumber: string;
  }

  /**
   * Parameters for MandantRemove
   */
  export interface MandantRemoveParams {
    sortimentId: number;
    catalogProductNumber: string;
  }
}

export { MandantService }
